import React from 'react'
import { Image } from '@shared/components/image'
import { Section } from '@shared/components/section'
import styled, { CSSObject } from 'styled-components'

interface SectionHowProps {
	maxCashback: string
	minValue: string
	maxValue: string
}

export function SectionHow({ maxCashback, minValue, maxValue }: SectionHowProps): JSX.Element {
	return (
		<Section>
			<TextTitle>Как работают Сбережения?</TextTitle>
			<ViewRoot>
				<ViewItem>
					<ImageStyled name='investHow1.png' alt='' />
					<Text>
						Клиент выбирает подходящую программу сбережений с доходностью от {minValue}% до{' '}
						{maxCashback}% годовых в приложении
					</Text>
				</ViewItem>
				<ViewItem>
					<ImageStyled name='investHow2.png' alt='' />
					<Text>
						Клиент заключает договор с КПК «Фонд Ипотечного Кредитования» и вносит сумму сбережения
						на счёт
					</Text>
				</ViewItem>
				<ViewItem last>
					<ImageStyled name='investHow3.png' alt='' />
					<Text>
						Размещённые средства выдаются в виде займов под залог ликвидных квартир с регистрацией в
						Росреестре через платформу Credit.Club
					</Text>
				</ViewItem>
			</ViewRoot>
		</Section>
	)
}

const ViewRoot = styled.div(
	({ theme }) =>
		({
			display: 'flex',
			paddingLeft: 20,
			paddingRight: 20,
			justifyContent: 'center',
			alignItems: 'flex-start',
			flexDirection: 'column',
			marginBottom: 60,
			[theme.mediaQueries.mediaMinWidthMobile]: {
				paddingLeft: 60,
				paddingRight: 60,
				marginBottom: 100,
				flexDirection: 'row',
				justifyContent: 'space-between',
				alignItems: 'flex-start',
			},
		} as CSSObject)
)

const TextTitle = styled.h2(({ theme }) => ({
	...theme.typography.header30_36,
	marginBottom: 20,
	paddingLeft: 20,
	paddingRight: 20,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.header56_60,
		marginBottom: 40,
		paddingLeft: 60,
		paddingRight: 60,
	},
}))

interface ViewItemProps {
	last?: boolean
}

const ViewItem = styled.div<ViewItemProps>(({ theme, last = false }) => ({
	flex: 1,
	maxWidth: 264,
	marginRight: 0,
	marginBottom: last ? 0 : 30,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginRight: last ? 0 : 20,
		marginBottom: 0,
		justifyContent: 'space-between',
	},
}))

const ImageStyled = styled(Image)(({ theme }) => ({
	width: 264,
	marginBottom: 10,
	aspectRatio: '264/200',
	[theme.mediaQueries.mediaMinWidthMobile]: {
		marginBottom: 30,
	},
}))

const Text = styled.p(({ theme }) => ({
	...theme.typography.text16_22,
	[theme.mediaQueries.mediaMinWidthMobile]: {
		...theme.typography.text18_24,
	},
}))
